import AscenderFonts from '@/assets/fonts/families/ascender';
import AvenirNextFonts from '@/assets/fonts/families/avenir-next';
import LandRoverOpenTypeFonts from '@/assets/fonts/families/land-rover-open-type';
import LandRoverWebFonts from '@/assets/fonts/families/land-rover-web';

const landRoverFonts = [
	...AscenderFonts,
	...AvenirNextFonts,
	...LandRoverOpenTypeFonts,
	...LandRoverWebFonts,
];

export default landRoverFonts;
